
document.querySelectorAll('[data-service-centers]').forEach(function (root) {
  if (root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  'use strict';

  // ── Section-scoped state ─────────────────────────────────────
  var SID = root.dataset.sectionId;
  var english = document.documentElement.lang.split('-')[0] === 'en';
  var translations = {"Glavni servisni center": "Main service center", "Pon": "Mon", "Tor": "Tue", "Sre": "Wed", "Čet": "Thu", "Pet": "Fri", "Sob": "Sat", "Ned": "Sun", "Po dogovoru": "By appointment", "Zaprto": "Closed", "Zaprto danes": "Closed today", "Odprto do ": "Open until ", "Odpre ob ": "Opens at ", " lokacij": " locations", " od ": " of ", "Tvoj brskalnik ne podpira geolokacije.": "Your browser does not support geolocation.", "Dostop do lokacije zavrnjen. Omogoči ga v nastavitvah brskalnika.": "Location access was denied. You can enable it in your browser settings.", "Lokacije ni mogoče določiti.": "Your location could not be determined.", "Zahtevek za lokacijo je potekel.": "The location request timed out.", "Lokacije ni bilo mogoče pridobiti.": "Your location could not be retrieved.", "Nalagam zemljevid…": "Loading map…", "Nalagam zemljevid (rezervni vir)…": "Loading map from an alternative source…", "Vaše e-vozilo lahko kadarkoli pripeljete v naš salon (pon–pet 9:00–19:00, sob 10:00–16:00); v servis ga odpeljemo naslednji delovni dan, ko je servis odprt. 📞 Priporočamo predhodno rezervacijo termina po telefonu.": "You can drop off your e-vehicle at our showroom during opening hours (Mon–Fri 9:00–19:00, Sat 10:00–16:00). We will take it to the service center on the next working day when the service center is open. 📞 We recommend booking an appointment by phone.", "Vsi dnevi": "All days", "Tvoja lokacija": "Your location", "Pot": "Directions", "Pokliči": "Call", "E-pošta": "Email", "Znamke": "Brands", "Opomba": "Note", "Delovni čas": "Opening hours", "Ni rezultatov. Poskusi z drugačnim iskalnim pojmom.": "No results. Try another search term.", "Iščem…": "Locating…", "Zemljevida trenutno ni mogoče naložiti. Servisne centre lahko poiščete na seznamu.": "The map could not be loaded. You can find service centers in the list."};
  function copy(value) { return english && translations[value] ? translations[value] : value; }
  var MARKER_CLASS = 'sc-leaflet-marker-' + SID;

  // ── CONFIG ───────────────────────────────────────────────────
  var CFG = {
    /* Primary + fallback CDNs. If the first is blocked (theme CSP / ad-blocker),
       the loader automatically tries the next. */
    leafletCSS:    'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css',
    leafletCSSAlt: 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css',
    leafletJS:     'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js',
    leafletJSAlt:  'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js',
    /* Standard OSM tiles. If they fail (blocked / rate-limited), the map
       automatically switches to the CARTO fallback below. */
    tileURL:      'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    tileAttr:     '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors',
    tileURLAlt:   'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
    tileAttrAlt:  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions" target="_blank" rel="noopener">CARTO</a>',
    sloveniaCenter: [46.15, 14.99],
    sloveniaZoom:   8,
    flyZoom:        14,
    jitter:         0.00025
  };

  // ── DATA ─────────────────────────────────────────────────────
  // To refine a pin: open the address in Google Maps, right-click → copy lat,lon,
  // and replace the coords array below.
  var PLACES = [
    { id:'evolt', company:'EVOLT d.o.o.', branch:copy("Glavni servisni center"),
      address:'Tržaška cesta 222, 1000 Ljubljana', city:'Ljubljana',
      coords:[46.03346,14.45070], phone:'+386 30 771 787', email:'info@evolt.si',
      hours:{ mon:[[9,14]], tue:[[9,14]], wed:[[9,14]], thu:[[9,14]], fri:[[9,14]] },
      note:copy("Vaše e-vozilo lahko kadarkoli pripeljete v naš salon (pon–pet 9:00–19:00, sob 10:00–16:00); v servis ga odpeljemo naslednji delovni dan, ko je servis odprt. 📞 Priporočamo predhodno rezervacijo termina po telefonu."),
      brands:['Teverun','ECO Speed','Langfeite','KuKirin','Engwe','Econo','Xiaomi','Segway-Ninebot','VSETT','Kaabo','Dualtron','Duotts','Joyor','Vigorous','Veleco','ComfyGo','Jobobike','Tenways'] },

    { id:'eko-lj', company:'EKO DRIVE d.o.o.', branch:'Ljubljana',
      address:'Tržaška cesta 222, 1000 Ljubljana', city:'Ljubljana',
      coords:[46.03346,14.45070], phone:'+386 70 835 200', email:'info.ekodrive@gmail.com',
      hours:{ mon:[[9,12],[13,14]], tue:[[9,12],[13,14]], wed:[[9,12],[13,14]], thu:[[9,12],[13,14]], fri:[[9,12],[13,14]] },
      brands:['Teverun','ECO Speed','Langfeite','Xiaomi','Segway-Ninebot','VSETT','Engwe','Kaabo','Vigorous'] },

    { id:'eko-ve', company:'ER SERVIS – NC Velenje', branch:'Velenje',
      address:'Kidričeva cesta 2B, 3320 Velenje', city:'Velenje',
      coords:[46.35973,15.11055], phone:'+386 70 128 498', email:'info.ekodrive@gmail.com',
      hours:{ mon:[[9,12],[13,16]], tue:[[9,12],[13,16]], wed:[[9,12],[13,16]], thu:[[9,12],[13,16]], fri:[[9,12],[13,16]] },
      brands:['Teverun','ECO Speed','Langfeite','Xiaomi','Segway-Ninebot','VSETT','Engwe','Kaabo','Vigorous'] },

    { id:'eko-do', company:'E-SERVIS DOMŽALE', branch:'Domžale',
      address:'Murnova ulica 19, 1230 Domžale', city:'Domžale',
      coords:[46.13935,14.59400], phone:'+386 40 381 656', email:'info.ekodrive@gmail.com',
      byAppointment:true,
      brands:['Teverun','ECO Speed','Langfeite','Xiaomi','Segway-Ninebot','VSETT','Engwe','Kaabo','Vigorous'] },

    { id:'eko-ms', company:'JDSF, Primož Sreš s.p.', branch:'Murska Sobota',
      address:'Ribiška 14, 9000 Murska Sobota', city:'Murska Sobota',
      coords:[46.65900,16.16720], phone:'+386 51 653 423', email:'info.ekodrive@gmail.com',
      byAppointment:true,
      brands:['Teverun','ECO Speed','Langfeite','Xiaomi','Segway-Ninebot','VSETT','Engwe','Kaabo','Vigorous'] },

    { id:'krgofix', company:'KrgoFix', branch:'Kranj',
      address:'Poštna ulica 3a, 4000 Kranj', city:'Kranj',
      coords:[46.23834,14.35506], phone:'+386 70 646 482', email:'servis@krgofix.si',
      hours:{ mon:[[8,18]], tue:[[8,18]], wed:[[8,18]], thu:[[8,18]], sat:[[9,14]] },
      brands:['Teverun','ECO Speed','Langfeite','KuKirin','Engwe','Xiaomi','Segway-Ninebot','VSETT','Dualtron','Duotts','Joyor','Vigorous','Veleco'] },

    { id:'mobistekla', company:'Mobistekla – EM servis d.o.o.', branch:'Ljubljana',
      address:'Tržaška cesta 5, 1000 Ljubljana', city:'Ljubljana',
      coords:[46.04881,14.50479], phone:'+386 51 494 000', email:'info@mobistekla.si',
      hours:{ mon:[[9,18]], tue:[[9,18]], wed:[[9,18]], thu:[[9,18]], fri:[[9,16]] },
      brands:['KuKirin','Xiaomi','Segway-Ninebot','Joyor'] },

    { id:'robbo', company:'ROBBO – Robotix d.o.o.', branch:'Trzin',
      address:'Brezovce 9, 1236 Trzin', city:'Trzin',
      coords:[46.12881,14.56094], phone:'+386 1 292 60 14', email:'info@robbo.si',
      byAppointment:true,
      brands:['Kaabo','Dualtron','Apollo','Asiwo'] },

    { id:'zare-ko', company:'ŽARE – Mlađenović in ostali d.n.o.', branch:'Ljubljana – Kodeljevo',
      address:'Povšetova ulica 88, 1000 Ljubljana', city:'Ljubljana',
      coords:[46.04935,14.52829], phone:'+386 1 540 19 50', email:'info@servis-zare.si',
      hours:{ mon:[[8,19]], tue:[[8,19]], wed:[[8,19]], thu:[[8,19]], fri:[[8,19]], sat:[[7,13]] },
      brands:['KuKirin','Xiaomi','Segway-Ninebot','Joyor'] },

    { id:'zare-cr', company:'ŽARE – Mlađenović in ostali d.n.o.', branch:'Ljubljana – Črnuče',
      address:'Dunajska cesta 421, 1231 Ljubljana – Črnuče', city:'Ljubljana',
      coords:[46.10157,14.52630], phone:'+386 1 561 01 70', email:'info@servis-zare.si',
      hours:{ mon:[[9,13],[15,19]], tue:[[9,13],[15,19]], wed:[[9,13],[15,19]], thu:[[9,13],[15,19]], fri:[[9,13],[15,19]], sat:[[9,13]] },
      brands:['KuKirin','Xiaomi','Segway-Ninebot','Joyor'] },

    { id:'zare-po', company:'ŽARE – Mlađenović in ostali d.n.o.', branch:'Ljubljana – Polje',
      address:'Zadobrovškova 18, 1000 Ljubljana', city:'Ljubljana',
      coords:[46.06850,14.58400], phone:'+386 1 528 35 15', email:'info@servis-zare.si',
      hours:{ mon:[[9,17]], tue:[[9,17]], wed:[[9,17]], thu:[[9,17]], fri:[[9,17]], sat:[[9,13]] },
      brands:['KuKirin','Xiaomi','Segway-Ninebot','Joyor'] },

    { id:'smart', company:'Smart Elektro – Pamp d.o.o.', branch:'Ljubljana',
      address:'Na griču 17, 1000 Ljubljana', city:'Ljubljana',
      coords:[46.02580,14.46830], phone:'+386 70 737 139', email:'info@eskuter.si',
      hours:{ mon:[[9,17]], tue:[[9,17]], wed:[[9,17]], thu:[[9,17]], fri:[[9,17]] },
      brands:['Yadea','NMOTO'] },

    { id:'citymoto', company:'CITY MOTO – LUKALE d.o.o.', branch:'Škofja vas',
      address:'Šmarjeta pri Celju 8, 3211 Škofja vas', city:'Škofja vas',
      coords:[46.27000,15.27300], phone:'+386 41 644 900',
      hours:{ mon:[[9,17]], tue:[[9,17]], wed:[[9,17]], thu:[[9,17]], fri:[[9,17]] },
      brands:[] },

    { id:'wasup', company:'WASUP – Wasup d.o.o.', branch:'Ljubljana',
      address:'Verovškova 60a, 1000 Ljubljana', city:'Ljubljana',
      coords:[46.08470,14.48420], phone:'+386 40 867 867', email:'info@wasup.si',
      hours:{ mon:[[9,17]], tue:[[9,17]], wed:[[9,17]], thu:[[9,17]], fri:[[9,17]] },
      brands:['Ecobike','Econic'] },

    { id:'vukan', company:"Vukan's Bike – Gregor Vukan s.p.", branch:'Apače',
      address:'Apače 66A, 9253 Apače', city:'Apače',
      coords:[46.69970,15.90890], phone:'+386 70 815 379', email:'vukansbike@gmail.com',
      hours:{ mon:[[9,17]], tue:[[9,17]], wed:[[9,17]], thu:[[9,17]], fri:[[9,17]] },
      brands:['KuKirin','Xiaomi','Segway-Ninebot','Joyor','Engwe','Duotts'] }
  ];

  var DAY_KEYS  = ['sun','mon','tue','wed','thu','fri','sat'];
  var DAY_SHORT = { mon:copy("Pon"), tue:copy("Tor"), wed:copy("Sre"), thu:copy("Čet"), fri:copy("Pet"), sat:copy("Sob"), sun:copy("Ned") };

  // ── State ────────────────────────────────────────────────────
  var S = {
    map: null,
    markers: new Map(),
    userMarker: null,
    userLatLng: null,
    activeId: null,
    distances: new Map(),
    filteredIds: PLACES.map(function (p) { return p.id; }),
    indexNumber: new Map()
  };
  PLACES.forEach(function (p, i) { S.indexNumber.set(p.id, i + 1); });

  // ── Helpers ──────────────────────────────────────────────────
  function $(id) { return document.getElementById(id + '-' + SID); }
  function escHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
  function haversine(a, b) {
    var R = 6371;
    var dLat = (b[0] - a[0]) * Math.PI / 180;
    var dLon = (b[1] - a[1]) * Math.PI / 180;
    var la1 = a[0] * Math.PI / 180, la2 = b[0] * Math.PI / 180;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2)
          + Math.cos(la1) * Math.cos(la2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.sqrt(x));
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function fmtTime(h) {
    var hr = Math.floor(h);
    var min = Math.round((h - hr) * 60);
    return pad2(hr) + ':' + pad2(min);
  }
  function getStatus(p, now) {
    now = now || new Date();
    if (p.byAppointment) return { kind:'appointment', label:copy("Po dogovoru") };
    if (!p.hours) return { kind:'closed', label:copy("Zaprto") };
    var todayKey = DAY_KEYS[now.getDay()];
    var slots = p.hours[todayKey];
    if (!slots || !slots.length) return { kind:'closed', label:copy("Zaprto danes") };
    var mins = now.getHours() * 60 + now.getMinutes();
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i][0], e = slots[i][1];
      if (mins >= s * 60 && mins < e * 60) return { kind:'open', label:copy("Odprto do ") + fmtTime(e) };
    }
    var next = null;
    for (var j = 0; j < slots.length; j++) {
      if (slots[j][0] * 60 > mins) { next = slots[j]; break; }
    }
    if (next) return { kind:'closed', label:copy("Odpre ob ") + fmtTime(next[0]) };
    return { kind:'closed', label:copy("Zaprto") };
  }
  function buildHoursTable(p) {
    if (p.byAppointment) {
      return '<div class="sc-pop-hours"><div><span class="day">' + copy("Vsi dnevi") + '</span><span>' + copy("Po dogovoru") + '</span></div></div>';
    }
    if (!p.hours) return '';
    var todayKey = DAY_KEYS[new Date().getDay()];
    var order = ['mon','tue','wed','thu','fri','sat','sun'];
    var rows = order.map(function (k) {
      var slots = p.hours[k];
      var isToday = k === todayKey;
      var cls = isToday ? ' class="today"' : '';
      var time = (slots && slots.length)
        ? slots.map(function (sl) { return fmtTime(sl[0]) + '–' + fmtTime(sl[1]); }).join(', ')
        : copy("Zaprto");
      return '<div' + cls + '><span class="day">' + DAY_SHORT[k] + '</span><span>' + time + '</span></div>';
    }).join('');
    return '<div class="sc-pop-hours">' + rows + '</div>';
  }

  // ── Markers ──────────────────────────────────────────────────
  function markerIcon(num, active) {
    return window.L.divIcon({
      className: MARKER_CLASS,
      html: '<div class="sc-marker' + (active ? ' is-active' : '') + '">' + num + '</div>',
      iconSize: [30, 30],
      iconAnchor: [15, 15],
      popupAnchor: [0, -15]
    });
  }
  function userIcon() {
    return window.L.divIcon({
      className: MARKER_CLASS,
      html: '<div class="sc-marker is-user" aria-label="' + copy("Tvoja lokacija") + '"></div>',
      iconSize: [22, 22],
      iconAnchor: [11, 11]
    });
  }
  function refreshMarkerIcons() {
    PLACES.forEach(function (p) {
      var m = S.markers.get(p.id);
      if (!m) return;
      m.setIcon(markerIcon(S.indexNumber.get(p.id), p.id === S.activeId));
    });
  }

  // ── Popup HTML ───────────────────────────────────────────────
  function buildPopupHTML(p) {
    var status = getStatus(p);
    var badge = '<span class="sc-badge is-' + status.kind + '">' + escHTML(status.label) + '</span>';
    var dirURL = 'https://www.google.com/maps/dir/?api=1&destination=' + p.coords[0] + ',' + p.coords[1];

    var links = [];
    links.push('<a class="sc-pop-link" href="' + dirURL + '" target="_blank" rel="noopener noreferrer">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg> ' + copy("Pot") + '</a>');
    if (p.phone) {
      var tel = p.phone.replace(/\s+/g, '');
      links.push('<a class="sc-pop-link" href="tel:' + escHTML(tel) + '">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg> ' + copy("Pokliči") + '</a>');
    }
    if (p.email) {
      links.push('<a class="sc-pop-link" href="mailto:' + escHTML(p.email) + '">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg> ' + copy("E-pošta") + '</a>');
    }

    var distance = S.distances.get(p.id);
    var distHTML = (distance !== undefined) ? ' <span class="sc-distance">· ' + distance.toFixed(1) + ' km</span>' : '';

    var brandsHTML = (p.brands && p.brands.length)
      ? '<div class="sc-pop-section"><h4>' + copy("Znamke") + '</h4><div>' +
        p.brands.map(function (b) { return '<span class="sc-pop-brand-pill">' + escHTML(b) + '</span>'; }).join('') +
        '</div></div>'
      : '';

    var noteHTML = p.note
      ? '<div class="sc-pop-section"><h4>' + copy("Opomba") + '</h4><div class="sc-pop-note">' + escHTML(p.note) + '</div></div>'
      : '';

    return ''
      + '<div class="sc-pop-title">' + escHTML(p.company) + '</div>'
      + (p.branch ? '<div class="sc-pop-sub">' + escHTML(p.branch) + distHTML + '</div>' : '')
      + '<div class="sc-pop-addr">' + escHTML(p.address) + '</div>'
      + '<div class="sc-pop-row">' + badge + '</div>'
      + '<div class="sc-pop-row">' + links.join('') + '</div>'
      + '<div class="sc-pop-section"><h4>' + copy("Delovni čas") + '</h4>' + buildHoursTable(p) + '</div>'
      + noteHTML
      + brandsHTML;
  }

  // ── List ─────────────────────────────────────────────────────
  function renderList() {
    var el = $('sc-list');
    if (!el) return;

    if (!S.filteredIds.length) {
      el.innerHTML = '<div class="sc-empty">' + copy("Ni rezultatov. Poskusi z drugačnim iskalnim pojmom.") + '</div>';
      updateStats();
      return;
    }

    var ordered = S.filteredIds.slice();
    if (S.distances.size) {
      ordered.sort(function (a, b) {
        var da = S.distances.has(a) ? S.distances.get(a) : Infinity;
        var db = S.distances.has(b) ? S.distances.get(b) : Infinity;
        return da - db;
      });
    }

    var frag = document.createDocumentFragment();
    ordered.forEach(function (id) {
      var p = null;
      for (var i = 0; i < PLACES.length; i++) { if (PLACES[i].id === id) { p = PLACES[i]; break; } }
      if (!p) return;

      var status = getStatus(p);
      var dist = S.distances.get(id);
      var isActive = id === S.activeId;

      var card = document.createElement('div');
      card.className = 'sc-card' + (isActive ? ' is-active' : '');
      card.setAttribute('data-id', id);
      card.setAttribute('role', 'option');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-selected', isActive ? 'true' : 'false');
      card.innerHTML = ''
        + '<div class="sc-card-row">'
        +   '<div class="sc-pin">' + S.indexNumber.get(id) + '</div>'
        +   '<div class="sc-card-body">'
        +     '<div class="sc-card-title">' + escHTML(p.company) + '</div>'
        +     '<div class="sc-card-sub">' + escHTML(p.branch || p.city) + '</div>'
        +     '<div class="sc-card-addr">' + escHTML(p.address) + '</div>'
        +     '<div class="sc-card-meta">'
        +       '<span class="sc-badge is-' + status.kind + '">' + escHTML(status.label) + '</span>'
        +       ((dist !== undefined) ? '<span class="sc-distance">' + dist.toFixed(1) + ' km</span>' : '')
        +     '</div>'
        +   '</div>'
        + '</div>';

      (function (theId) {
        card.addEventListener('click', function () { selectPlace(theId, 'list'); });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectPlace(theId, 'list');
          }
        });
      })(id);

      frag.appendChild(card);
    });

    el.replaceChildren ? el.replaceChildren(frag) : (el.innerHTML = '', el.appendChild(frag));
    updateStats();
  }

  function updateStats() {
    var el = $('sc-stats');
    if (!el) return;
    var total = PLACES.length;
    var shown = S.filteredIds.length;
    el.textContent = (shown === total) ? (total + copy(" lokacij")) : (shown + copy(" od ") + total + copy(" lokacij"));
  }

  // ── Selection ────────────────────────────────────────────────
  function selectPlace(id, source) {
    var p = null;
    for (var i = 0; i < PLACES.length; i++) { if (PLACES[i].id === id) { p = PLACES[i]; break; } }
    if (!p) return;

    S.activeId = id;
    renderList();

    /* On mobile, picking from the list jumps to the map so the result is
       actually visible (the whole point of the toggle UX). */
    if (source === 'list' && isMobile()) setView('map');

    whenMapReady(function () {
      refreshMarkerIcons();
      S.map.invalidateSize(); /* in case the map pane was just revealed */
      S.map.flyTo(p.coords, Math.max(CFG.flyZoom, S.map.getZoom()), { duration: 0.6 });
      var marker = S.markers.get(id);
      if (marker) {
        /* Open the popup only once the map has finished moving, so Leaflet's
           auto-pan can keep the whole popup in view (prevents the cut-off top). */
        var opened = false;
        var openIt = function () { if (!opened) { opened = true; marker.openPopup(); } };
        S.map.once('moveend', openIt);
        setTimeout(openIt, 800); /* fallback if the map barely moves */
      }
    });

    if (source !== 'list') {
      setTimeout(function () {
        var sel = '#sc-' + SID + ' .sc-card[data-id="' + id + '"]';
        var card = document.querySelector(sel);
        if (card) card.scrollIntoView({ behavior:'smooth', block:'nearest' });
      }, 50);
    }
  }

  // ── Search ───────────────────────────────────────────────────
  function buildIndex() {
    PLACES.forEach(function (p) {
      p._idx = [p.company, p.branch || '', p.city, p.address].concat(p.brands || []).join(' ').toLowerCase();
    });
  }
  function runSearch(q) {
    q = q.trim().toLowerCase();
    if (!q) {
      S.filteredIds = PLACES.map(function (p) { return p.id; });
    } else {
      S.filteredIds = PLACES.filter(function (p) { return p._idx.indexOf(q) !== -1; }).map(function (p) { return p.id; });
    }
    renderList();
  }

  // ── Geolocation ──────────────────────────────────────────────
  function findNearest() {
    if (!S.map) { whenMapReady(findNearest); return; }
    if (!('geolocation' in navigator)) {
      alert(copy("Tvoj brskalnik ne podpira geolokacije."));
      return;
    }
    var btn = $('sc-nearest');
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> ' + copy("Iščem…");

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        if (isMobile()) setView('map'); /* show the result on mobile */
        S.userLatLng = [pos.coords.latitude, pos.coords.longitude];
        PLACES.forEach(function (p) { S.distances.set(p.id, haversine(S.userLatLng, p.coords)); });

        if (S.userMarker) S.map.removeLayer(S.userMarker);
        S.userMarker = window.L.marker(S.userLatLng, { icon: userIcon(), zIndexOffset: 1000 })
          .addTo(S.map)
          .bindPopup('<strong>' + copy("Tvoja lokacija") + '</strong>');

        var candidate = S.filteredIds.length ? S.filteredIds : PLACES.map(function (p) { return p.id; });
        var nearestId = candidate.slice().sort(function (a, b) {
          return S.distances.get(a) - S.distances.get(b);
        })[0];
        var nearest = null;
        for (var i = 0; i < PLACES.length; i++) { if (PLACES[i].id === nearestId) { nearest = PLACES[i]; break; } }

        var bounds = window.L.latLngBounds([S.userLatLng, nearest.coords]).pad(0.4);
        S.map.fitBounds(bounds, { maxZoom: 14 });

        S.activeId = nearestId;
        refreshMarkerIcons();
        renderList();

        var m = S.markers.get(nearestId);
        if (m) setTimeout(function () { m.openPopup(); }, 500);

        btn.disabled = false;
        btn.innerHTML = original;
      },
      function (err) {
        btn.disabled = false;
        btn.innerHTML = original;
        var map = { 1:copy("Dostop do lokacije zavrnjen. Omogoči ga v nastavitvah brskalnika."), 2:copy("Lokacije ni mogoče določiti."), 3:copy("Zahtevek za lokacijo je potekel.") };
        alert(map[err.code] || copy("Lokacije ni bilo mogoče pridobiti."));
      },
      { enableHighAccuracy:false, timeout:10000, maximumAge:60000 }
    );
  }

  // ── Map init ─────────────────────────────────────────────────
  function initMap() {
    if (!window.L) return;
    if (S.map) { S.map.invalidateSize(); return; } /* already initialised */
    var mapEl = $('sc-map');
    if (!mapEl) return;

    /* Defensive: if the container is still 0×0 (theme just inserted it),
       wait one frame and try again. Critical for theme-editor reloads. */
    if (mapEl.offsetWidth === 0 || mapEl.offsetHeight === 0) {
      requestAnimationFrame(initMap);
      return;
    }

    var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    var map = window.L.map(mapEl, {
      center: CFG.sloveniaCenter,
      zoom: CFG.sloveniaZoom,
      scrollWheelZoom: !isTouch,
      preferCanvas: true,
      worldCopyJump: false,
      /* Hide +/- buttons on touch (pinch-zoom is standard there) so they can't
         overlap popups on a narrow screen; keep them on desktop/mouse. */
      zoomControl: !isTouch
    });

    var primaryTiles = window.L.tileLayer(CFG.tileURL, {
      attribution: CFG.tileAttr,
      maxZoom: 19,
      detectRetina: true,
      crossOrigin: true
    });
    /* If OSM tiles get blocked or rate-limited, switch to CARTO automatically. */
    var tileErrors = 0, switched = false;
    primaryTiles.on('tileerror', function () {
      tileErrors++;
      if (!switched && tileErrors >= 3) {
        switched = true;
        map.removeLayer(primaryTiles);
        window.L.tileLayer(CFG.tileURLAlt, {
          attribution: CFG.tileAttrAlt,
          maxZoom: 19,
          detectRetina: true,
          crossOrigin: true,
          subdomains: 'abcd'
        }).addTo(map);
      }
    });
    primaryTiles.on('load', function () { setStatus('', false); });
    primaryTiles.addTo(map);

    S.map = map;

    /* Size popups to the viewport so they never overflow a narrow phone. */
    var vw = window.innerWidth || document.documentElement.clientWidth || 360;
    var popupMaxW = Math.max(220, Math.min(320, vw - 48));
    var popupOpts = {
      maxWidth: popupMaxW,
      minWidth: Math.min(240, popupMaxW),
      autoPanPadding: [20, 40],
      keepInView: true
    };

    var usedKeys = new Map();
    var bounds = window.L.latLngBounds();

    PLACES.forEach(function (p) {
      var key = p.coords.join(',');
      var count = (usedKeys.get(key) || 0) + 1;
      usedKeys.set(key, count);
      var offset = count > 1 ? CFG.jitter * (count - 1) : 0;
      var ll = [p.coords[0] + offset, p.coords[1] + offset];

      var marker = window.L.marker(ll, {
        icon: markerIcon(S.indexNumber.get(p.id), false),
        riseOnHover: true,
        title: p.company + (p.branch ? ' – ' + p.branch : '')
      }).addTo(map);

      marker.bindPopup(buildPopupHTML(p), popupOpts);

      (function (theId, thePlace, theMarker) {
        theMarker.on('click', function () { selectPlace(theId, 'map'); });
        /* Refresh popup content every time it opens so status badges stay live. */
        theMarker.on('popupopen', function () { theMarker.setPopupContent(buildPopupHTML(thePlace)); });
      })(p.id, p, marker);

      S.markers.set(p.id, marker);
      bounds.extend(ll);
    });

    map.fitBounds(bounds.pad(0.15));

    /* The two lines that fix "map not showing": Leaflet often
       measures itself before the layout is final. Recompute. */
    setTimeout(function () { map.invalidateSize(); }, 50);
    setTimeout(function () { map.invalidateSize(); }, 300);

    if ('ResizeObserver' in window) {
      try {
        new ResizeObserver(function () { map.invalidateSize(); }).observe(mapEl);
      } catch (e) { /* noop */ }
    }
    /* Theme editor also fires this when the merchant edits the section. */
    document.addEventListener('shopify:section:load', function () { map.invalidateSize(); });
  }

  // ── Visible status / diagnostics ─────────────────────────────
  /* Writes a message into the on-map box so problems are visible on the
     page itself — no need to open the browser console. */
  function setStatus(msg, isError) {
    var box = $('sc-error');
    if (!box) return;
    if (!msg) { box.hidden = true; box.textContent = ''; return; }
    box.hidden = false;
    box.textContent = msg;
    box.style.background = isError ? '#fee2e2' : '#fef3c7';
    box.style.color = isError ? '#991b1b' : '#92400e';
  }

  // ── Leaflet loader (cached, idempotent, with CDN fallback) ───
  var leafletPromise = null;
  function loadLeaflet() {
    if (window.L && typeof window.L.map === 'function') return Promise.resolve();
    if (leafletPromise) return leafletPromise;

    /* Inject CSS (try primary; swap to fallback if it errors). */
    if (!document.getElementById('sc-leaflet-css')) {
      var link = document.createElement('link');
      link.id = 'sc-leaflet-css';
      link.rel = 'stylesheet';
      link.href = CFG.leafletCSS;
      link.onerror = function () { link.href = CFG.leafletCSSAlt; };
      document.head.appendChild(link);
    }

    function injectScript(src) {
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.className = 'sc-leaflet-js';
        s.src = src;
        s.async = true;
        var done = false;
        var timer = setTimeout(function () {
          if (!done) { done = true; reject(new Error('timeout')); }
        }, 8000);
        s.onload = function () {
          if (done) return; done = true; clearTimeout(timer);
          (window.L && typeof window.L.map === 'function') ? resolve() : reject(new Error('no L'));
        };
        s.onerror = function () {
          if (done) return; done = true; clearTimeout(timer);
          reject(new Error('error'));
        };
        document.head.appendChild(s);
      });
    }

    setStatus(copy("Nalagam zemljevid…"), false);
    leafletPromise = injectScript(CFG.leafletJS)
      .catch(function () {
        /* Primary CDN blocked or timed out — try the fallback CDN. */
        setStatus(copy("Nalagam zemljevid (rezervni vir)…"), false);
        return injectScript(CFG.leafletJSAlt);
      });
    return leafletPromise;
  }

  // ── Bootstrap ────────────────────────────────────────────────
  function bootstrap() {
    var root = document.getElementById('sc-' + SID);
    if (!root) return; /* section unmounted */
    /* Default mobile pane = map (ignored on desktop, where both panes show).
       If JS never runs, neither class is set and CSS falls back to stacked. */
    root.classList.add('view-map');
    buildIndex();
    renderList();
    wireUI();
    lazyLoadMap();
  }

  function wireUI() {
    var wrap = $('sc-search-wrap');
    var search = $('sc-search');
    var clear = $('sc-clear');
    var nearest = $('sc-nearest');

    if (search) {
      var t;
      search.addEventListener('input', function (e) {
        var v = e.target.value;
        if (wrap) wrap.classList.toggle('has-text', !!v);
        clearTimeout(t);
        t = setTimeout(function () { runSearch(v); }, 120);
      });
      search.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          search.value = '';
          if (wrap) wrap.classList.remove('has-text');
          runSearch('');
        }
      });
    }
    if (clear) clear.addEventListener('click', function () {
      search.value = '';
      if (wrap) wrap.classList.remove('has-text');
      runSearch('');
      search.focus();
    });
    if (nearest) nearest.addEventListener('click', findNearest);

    /* Map ⇄ List toggle (visible only on mobile/tablet via CSS). */
    var vtBtns = document.querySelectorAll('#sc-' + SID + ' .sc-vt-btn');
    for (var i = 0; i < vtBtns.length; i++) {
      vtBtns[i].addEventListener('click', function () {
        setView(this.getAttribute('data-view'));
      });
    }
  }

  /* Load Leaflet + build the map once. Safe to call repeatedly. */
  var mapStarting = false;
  function ensureMap() {
    if (S.map) { S.map.invalidateSize(); return; }
    if (mapStarting) return;
    mapStarting = true;
    loadLeaflet().then(initMap).catch(function () {
      mapStarting = false;
      /* Both CDNs failed → almost always a theme Content-Security-Policy
         blocking external scripts. Tell the merchant exactly that. */
      setStatus(copy("Zemljevida trenutno ni mogoče naložiti. Servisne centre lahko poiščete na seznamu."), true);
    });
  }

  /* Run cb once the map object exists (loading it if necessary). */
  function whenMapReady(cb) {
    if (S.map) { cb(); return; }
    ensureMap();
    var tries = 0;
    (function wait() {
      if (S.map) { cb(); return; }
      if (tries++ > 120) return; /* ~6s safety cap */
      setTimeout(wait, 50);
    })();
  }

  function lazyLoadMap() {
    var mapEl = $('sc-map');
    if (!mapEl) return;
    if (!('IntersectionObserver' in window)) { ensureMap(); return; }
    var obs = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { obs.disconnect(); ensureMap(); return; }
      }
    }, { rootMargin: '300px' });
    obs.observe(mapEl);
  }

  // ── View toggle (mobile/tablet) ──────────────────────────────
  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 900px)').matches);
  }
  function setView(view) {
    var root = document.getElementById('sc-' + SID);
    if (!root) return;
    root.classList.remove('view-list', 'view-map');
    root.classList.add('view-' + view);
    var btns = root.querySelectorAll('.sc-vt-btn');
    for (var i = 0; i < btns.length; i++) {
      var on = btns[i].getAttribute('data-view') === view;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-selected', on ? 'true' : 'false');
    }
    if (view === 'map') {
      ensureMap();
      if (S.map) S.map.invalidateSize();
      /* Recompute after the pane becomes visible (display change). */
      setTimeout(function () { if (S.map) S.map.invalidateSize(); }, 90);
    }
  }

  bootstrap();
});
